import { isPresent } from 'utils/isPresent';
import React, { PureComponent } from 'react';
import Snackbar from 'housecall-ui/dist/DesignSystem/Feedback/Snackbar/Snackbar';
import SnackbarContent from 'housecall-ui/dist/DesignSystem/Feedback/Snackbar/SnackbarContent';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import ui from 'redux-ui';
import Cookies from 'universal-cookie';

import RestApi from './restApi';

export const SNACKBAR_TEXT = 'SNACKBAR_TEXT';

const styles = {
  snackBarContent: {
    margin: '0 auto',
  },
};

@ui({
  state: {
    text: '',
    actionUrl: '',
  },
  reducer: (state, action) => {
    switch (action.type) {
      case SNACKBAR_TEXT:
        return state.set('text', action.text);
    }
    return state;
  },
})
@withStyles(styles)
export default class HCSnackbar extends PureComponent {
  constructor(props) {
    super(props);

    this.cookies = new Cookies();
  }

  componentDidMount() {
    if (this.cookies.get('openSnackBar') === 'true') {
      this.props.updateUI('text', this.cookies.get('snackBarMessage'));
      this.cookies.remove('openSnackBar', { path: '/' });
      this.cookies.remove('snackBarMessage', { path: '/' });
    }
    if (isPresent(this.cookies.get('actionUrl'))) {
      this.props.updateUI('actionUrl', this.cookies.get('actionUrl'));
    }
  }

  componentWillUnmount() {
    this.cookies.remove('openSnackBar', { path: '/' });
  }

  undoActionAndCloseSnackbar(url) {
    this.cookies.remove('openSnackBar', { path: '/' });

    return RestApi.postWithFormData(url)
      .then((response) => {
        if (response.data.redirect_url) {
          window.location = response.data.redirect_url;
        }
      })
      .catch(() => {});
  }

  actionButton() {
    return (
      <Button
        color="primary"
        size="small"
        dense
        onClick={() => {
          this.undoActionAndCloseSnackbar(this.props.ui.actionUrl);
        }}
      >
        UNDO
      </Button>
    );
  }

  render() {
    return (
      <HousecallThemeProvider>
        <Snackbar
          open={isPresent(this.props.ui.text)}
          children={
            <SnackbarContent
              classes={{ message: this.props.classes.snackBarContent }}
              message={this.props.ui.text}
              action={this.props.ui.actionUrl ? this.actionButton() : null}
            />
          }
          anchorOrigin={this.props.anchorOrigin}
          autoHideDuration={4000}
          onClose={() => {
            this.props.updateUI('text', '');
            this.cookies.remove('openSnackBar', { path: '/' });
          }}
        />
      </HousecallThemeProvider>
    );
  }
}

HCSnackbar.defaultProps = { anchorOrigin: { vertical: 'bottom', horizontal: 'center' } };
